




























































































































































































































































import 'reflect-metadata'
import { Component, Vue } from 'vue-property-decorator'
import { ViewDataFromEmailApi } from '@/api'
import NotificationWithOutExit from "@/components/common/notification/NotificationWithOutExit.vue"
import { config } from '../../config'

@Component({
    components: {
        'common-notification-notification': NotificationWithOutExit
    }
})
export default class EmailTransfer extends Vue {
    loading: boolean = false
    
    isData:boolean = false
    username: string = ""
    email: string = ""
    dateTimeText: string = ""
    readDate: string = ""
    projectName: string = ""
    productId: string = ""
    transferDate: string = ""
    unitEmailTransferList: any[] = []
    unitEmailTransferOutList: any[] = []

    projectLists = [] as any

    async mounted() {
        await this.SetGetReportEmailTransfer()
    }

    async SetGetReportEmailTransfer() {
        try {
            const qs = this.$route.query
            const projectId = qs.pid ?? ""
            const transferDate = qs.date ?? ""
            

            if (projectId !== "" && transferDate !== "") 
            {
                this.loading = true
                const response = await ViewDataFromEmailApi.GetEmailTransfer({
                    projectId: parseInt(`${projectId}`),
                    transferDate: transferDate
                })

                this.isData = response.unitEmailTransferList.length + response.unitEmailTransferOutList.length == 0 ? false : true
                this.username = response.userName
                this.email = response.email
                this.readDate = response.readDate
                this.dateTimeText = response.dateTimeText
                this.projectName = `${response.projectCode} ${response.projectName}`
                this.productId = response.productId
                this.transferDate = response.transferDate
                this.unitEmailTransferList = response.unitEmailTransferList
                this.unitEmailTransferOutList = response.unitEmailTransferOutList
                this.loading = false
            }

        } catch (error) {
            this.notification('ไม่พบข้อมูล', 'warning') 
        }
    }

    isCondo (productId: string) {
        return productId != '2'
    }

    openLinkSiriDocument (item: any) {
        const paramsJson = {
            user_id: "1646",
            user_code: "sys_TransferPlanning",
            unit_code: item.unitCode,
            unit_id: item.unitId,
            ProjectName: item.projectName,
            Project_id: item.projectId,
            Prospect_id: item.prospectId,
            ProspectName: item.prospectName
        }
        const searchParams = new URLSearchParams(paramsJson);
        const queryString = searchParams.toString();
        const url = `${config.siriApp4Url}/siridocument/Prospect_popupAttfile_Edit.aspx?${queryString}`
        window.open(url, '_blank')
    }

    openLinkQuotation (item: any) {
        const paramsJson = {
            PJ: item.unitCode.split("-")[0],
            Unit_id: item.unitId,
            SAPCustomer_Num: item.contractNum ?? ""
        }
        const searchParams = new URLSearchParams(paramsJson);
        const queryString = searchParams.toString();
        const url = `${config.siriApp3Url}/quotation/Report/Rpt_PayTrans.aspx?${queryString}`
        window.open(url, '_blank')
    }

    notification (text: string, status: string) {
        const child = this.$refs.refNotification as any
        child.openNotification(text, status)
    }
}
